<template>
  <div>
    <GreetingBanner />
    <VaNavbar class="app-layout-navbar py-2 px-0">
      <template #left>
        <div class="left">
          <Transition v-if="isMobile" name="icon-fade" mode="out-in">
            <VaIcon
              color="primary"
              :name="isSidebarMinimized ? 'menu' : 'close'"
              size="24px"
              style="margin-top: 3px"
              @click="isSidebarMinimized = !isSidebarMinimized"
            />
          </Transition>

          <!-- Logo de l'entreprise -->
          <div class="company-logo">
            <div v-if="companyLogoUrl" class="logo-image" :style="{ backgroundImage: `url(${companyLogoUrl})` }"></div>
            <div v-else class="logo-initials">{{ companyInitials }}</div>
          </div>

          <SettingsPanel />
        </div>
      </template>
      <template #right>
        <AppNavbarActions class="app-navbar__actions" :is-mobile="isMobile" />
      </template>
    </VaNavbar>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { useGlobalStore } from '../../stores/global-store'
import AppNavbarActions from './components/AppNavbarActions.vue'
import SettingsPanel from '../SettingsPanel.vue'
import GreetingBanner from './components/GreetingBanner.vue'

defineProps({
  isMobile: { type: Boolean, default: false },
})

const GlobalStore = useGlobalStore()
const { isSidebarMinimized } = storeToRefs(GlobalStore)

const companyName = ref('PROGRESS SYSTEMS')
const companyLogoUrl = ref('/logo_jpcc.png') // Logo fixe dans public/

// Calculer les initiales de l'entreprise
const companyInitials = computed(() => {
  if (!companyName.value) return '??'
  const words = companyName.value.split(' ')
  if (words.length >= 2) {
    return (words[0][0] + words[1][0]).toUpperCase()
  }
  return companyName.value.substring(0, 2).toUpperCase()
})

// Logo et nom de la company sont maintenant fixés en dur (voir lignes 44-45)
// Si vous voulez les charger depuis la base de données, décommentez le code ci-dessous:

/*
// Charger les informations de l'entreprise
const loadCompanyInfo = async () => {
  try {
    const apiBaseUrl = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8080/api'
    const response = await fetch(`${apiBaseUrl}/companies`, { credentials: 'include' })

    if (response.ok) {
      const companies = await response.json()
      console.log('Companies chargées:', companies)
      if (companies && companies.length > 0) {
        const company = companies[0] // Prendre la première entreprise
        companyName.value = company.name || ''
        console.log('Company name:', companyName.value)

        if (company.logoUrl) {
          console.log('Logo URL depuis l\'API:', company.logoUrl)
          companyLogoUrl.value = company.logoUrl
          console.log('Logo URL finale:', companyLogoUrl.value)
        }
      }
    }
  } catch (error) {
    console.error('Erreur lors du chargement des informations de l\'entreprise:', error)
  }
}

onMounted(() => {
  loadCompanyInfo()
})
*/
</script>

<style lang="scss" scoped>
.va-navbar {
  z-index: 2;

  @media screen and (max-width: 950px) {
    .left {
      width: 100%;
    }

    .app-navbar__actions {
      display: flex;
      justify-content: space-between;
    }
  }
}

.left {
  display: flex;
  align-items: center;
  margin-left: 1rem;

  & > * {
    margin-right: 1rem;
  }

  & > *:last-child {
    margin-right: 0;
  }
}

.company-logo {
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo-image {
  width: 100px;
  height: 60px;
  border-radius: 8px;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  border: 1px solid var(--va-background-border);
}

.logo-initials {
  width: 100px;
  height: 60px;
  border-radius: 8px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.25rem;
  font-weight: bold;
  color: white;
  border: 1px solid var(--va-background-border);
}

.icon-fade-enter-active,
.icon-fade-leave-active {
  transition: transform 0.5s ease;
}

.icon-fade-enter,
.icon-fade-leave-to {
  transform: scale(0.5);
}
</style>
